import { useState } from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import copy from 'copy-text-to-clipboard';
import ahoy from 'ahoy.js';
import flash from 'shared/flash';
import loadPinterest from './shared/pinterest';
import { breedsToString, listingPath } from './shared/listing_helpers';

const X_HASHTAGS = ["myrighthorse", "aspca"];
const FACEBOOK_HASHTAG = "myrighthorse";

export default function PopoverShare({listing, noToggler, userType, userID}) {
  const {id, cover, name, age, breeds, gender, location} = listing;
  const url = listing.url || listingPath(listing.slug);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = (e) => {
    e.preventDefault();
    setPopoverOpen(!popoverOpen);
  };

  const trackShare = (share_type) => {
    const ahoy_props = {share_type, listing_id: id, url: window.location.href};
    if (userType && userID) {
      ahoy_props.user_type = userType
      ahoy_props.user_id = userID
    }

    ahoy.track("LISTING_SHARE", ahoy_props);
  };

  const copyLink = () => {
    if (copy(url)) {
      flash('success', 'Link Copied!');
    }
  };

  const fbShare = () => {
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&hashtag=%23${FACEBOOK_HASHTAG}`;
    window.open(fbUrl, 'facebook-popup', 'height=350, width=600');
  };

  const xShare = () => {
    const hashtags = _.join([X_HASHTAGS, breedsToString(breeds).replace(/ /g, '')], ',');
    const xUrl = `https://twitter.com/share?url=${url}&hashtags=${hashtags}`;
    window.open(xUrl, 'twitter-popup', 'height=350,width=600');
  }

  const pinterestShare = async () => {
    const PinUtils = await loadPinterest();
    if (!PinUtils) return alert("Pintrest did not successfully load.");

    PinUtils.pinOne({
      url,
      media: cover,
      description: `${name} is a ${age} year old #${breedsToString(breeds)} ${gender} in ${location.city}, ${location.state}. #myrighthorse`
    });
  };

  const share = (source, method) => (e) => {
    e.preventDefault();
    trackShare(source);
    method();
  };

  const SocialShareButtons = <>
    <i className="icon-copy-regular share-link"
      title="Copy link to Clipboard"
      onClick={share('link', copyLink)}/>
    <i className="icon-facebook-squared share-link"
      title="Share to Facebook"
      onClick={share('facebook', fbShare)}/>
    <i className="icon-x-twitter share-link"
      title="Share to X"
      onClick={share('twitter', xShare)}/>
    <i className="icon-pinterest-squared share-link"
      title="Share to Pinterest"
      onClick={share('pintrest', pinterestShare)}/>
  </>;

  return noToggler ? (
    <span className="col-12 justify-content-around d-flex">
      {SocialShareButtons}
    </span>
  ) : <>
    <span>
      <i id={`Popover-${id}`} className="icon-share-solid share-popover" onClick={toggle}/>
      <Popover target={`Popover-${id}`} placement="left" isOpen={popoverOpen} toggle={toggle}>
        <PopoverBody>{SocialShareButtons}</PopoverBody>
      </Popover>
    </span>
  </>;
}
